import createSelectors from './createSelectors';
import QuestionnaireRecord from '../models/QuestionnaireRecord';

const Select = createSelectors(QuestionnaireRecord, {});

export default Select;
